// Shared pixel heights for the app's fixed top bars (header + breadcrumb),
// so the sidebar and page content always align flush beneath them.
export const HEADER_HEIGHT = 64;
export const BREADCRUMB_BAR_HEIGHT = 32;
export const TOP_BAR_HEIGHT = HEADER_HEIGHT + BREADCRUMB_BAR_HEIGHT;
